import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useFinanceModuleFlag } from "../hooks/useFinanceModuleFlag";

type FinanceAccessRouteProps = {
  children: ReactNode;
};

const FinanceAccessRoute = ({ children }: FinanceAccessRouteProps) => {
  const { enabled, loading } = useFinanceModuleFlag();

  if (loading) {
    return null;
  }

  if (!enabled) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default FinanceAccessRoute;
